import "primeflex/primeflex.css";
import "primevue/resources/themes/lara-light-green/theme.css";
import "primeicons/primeicons.css";
import "../primeicons-display.css";
import "../../c/themes/main.css";
import PrimeVue from 'primevue/config';
import Tooltip from 'primevue/tooltip';
import BadgeDirective from 'primevue/badgedirective';
import ToastService from 'primevue/toastservice';
import Divider from "primevue/divider";

// P.S. не подключать директорию Ripple! На момент v3.48.1 сломана наглухо, распирает страницу по ширине и высоте!
export default (app) => {
    app
        .directive('tooltip', Tooltip)
        .directive('badge', BadgeDirective)
        .component('Divider', Divider)
        .use(ToastService)
        .use(PrimeVue, {
            ripple: false,
            locale: {
                startsWith: 'Starts with',
                contains: 'Contains',
                notContains: 'Not contains',
                endsWith: 'Ends with',
                equals: 'Equals',
                notEquals: 'Not equals',
                noFilter: 'No Filter',
                lt: 'Less than',
                lte: 'Less than or equal to',
                gt: 'Greater than',
                gte: 'Greater than or equal to',
                dateIs: 'Date is',
                dateIsNot: 'Date is not',
                dateBefore: 'Date is before',
                dateAfter: 'Date is after',
                clear: 'Clear',
                apply: 'Apply',
                matchAll: 'Match All',
                matchAny: 'Match Any',
                addRule: 'Add Rule',
                removeRule: 'Remove Rule',
                accept: 'Yes',
                reject: 'No',
                choose: 'Выберите файл',
                upload: 'Upload',
                cancel: 'Cancel',
                completed: 'Completed',
                pending: 'Pending',
                dayNames: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
                dayNamesShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
                dayNamesMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
                monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
                monthNamesShort: ['Янв', 'Февр', 'Март', 'Апр', 'Май', 'Июнь', 'Июль', 'Авг', 'Сент', 'Окт', 'Нояб', 'Дек'],
                chooseYear: 'Choose Year',
                chooseMonth: 'Choose Month',
                chooseDate: 'Choose Date',
                prevDecade: 'Previous Decade',
                nextDecade: 'Next Decade',
                prevYear: 'Previous Year',
                nextYear: 'Next Year',
                prevMonth: 'Previous Month',
                nextMonth: 'Next Month',
                prevHour: 'Previous Hour',
                nextHour: 'Next Hour',
                prevMinute: 'Previous Minute',
                nextMinute: 'Next Minute',
                prevSecond: 'Previous Second',
                nextSecond: 'Next Second',
                am: 'am',
                pm: 'pm',
                today: 'Today',
                weekHeader: 'Wk',
                firstDayOfWeek: 1,
                dateFormat: 'yy-mm-dd',
                weak: 'Слабый',
                medium: 'Средний',
                strong: 'Сложный',
                passwordPrompt: 'Введите пароль',
                emptyFilterMessage: 'Результатов не найдено', // @deprecated Use 'emptySearchMessage' option instead.
                searchMessage: '{0} доступно результатов',
                selectionMessage: '{0} выбрано элементов',
                emptySelectionMessage: 'Нет выбранных элементов',
                emptySearchMessage: 'Результатов не найдено',
                emptyMessage: 'Результатов не найдено',
                aria: {
                    trueLabel: 'True',
                    falseLabel: 'False',
                    nullLabel: 'Not Selected',
                    star: '1 star',
                    stars: '{star} stars',
                    selectAll: 'All items selected',
                    unselectAll: 'All items unselected',
                    close: 'Close',
                    previous: 'Previous',
                    next: 'Next',
                    navigation: 'Navigation',
                    scrollTop: 'Scroll Top',
                    moveTop: 'Move Top',
                    moveUp: 'Move Up',
                    moveDown: 'Move Down',
                    moveBottom: 'Move Bottom',
                    moveToTarget: 'Move to Target',
                    moveToSource: 'Move to Source',
                    moveAllToTarget: 'Move All to Target',
                    moveAllToSource: 'Move All to Source',
                    pageLabel: '{page}',
                    firstPageLabel: 'First Page',
                    lastPageLabel: 'Last Page',
                    nextPageLabel: 'Next Page',
                    prevPageLabel: 'Previous Page',
                    rowsPerPageLabel: 'Rows per page',
                    jumpToPageDropdownLabel: 'Jump to Page Dropdown',
                    jumpToPageInputLabel: 'Jump to Page Input',
                    selectRow: 'Row Selected',
                    unselectRow: 'Row Unselected',
                    expandRow: 'Row Expanded',
                    collapseRow: 'Row Collapsed',
                    showFilterMenu: 'Show Filter Menu',
                    hideFilterMenu: 'Hide Filter Menu',
                    filterOperator: 'Filter Operator',
                    filterConstraint: 'Filter Constraint',
                    editRow: 'Row Edit',
                    saveEdit: 'Save Edit',
                    cancelEdit: 'Cancel Edit',
                    listView: 'List View',
                    gridView: 'Grid View',
                    slide: 'Slide',
                    slideNumber: '{slideNumber}',
                    zoomImage: 'Zoom Image',
                    zoomIn: 'Zoom In',
                    zoomOut: 'Zoom Out',
                    rotateRight: 'Rotate Right',
                    rotateLeft: 'Rotate Left'
                }
            }
        })
};
